<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-row>
      <b-col
        cols="12"
        sm="4"
      >
        <router-link :to="{ name: 'logistics-officer.reservations.pending'}">
          <iq-card>
            <template v-slot:body>
              <div class="d-flex d-flex align-items-center justify-content-between">
                <div>
                  <h2>{{ reservations.pending }}</h2>
                  <p class="fontsize-sm m-0">
                    Pending Reservation(s)
                  </p>
                </div>
                <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-warning">
                  <i class="ri-inbox-fill" />
                </div>
              </div>
            </template>
          </iq-card>
        </router-link>
      </b-col>
      <b-col
        cols="12"
        sm="4"
      >
        <router-link :to="{ name: 'logistics-officer.reservations.histories', params: {status: 'Approved'}}">
          <iq-card>
            <template v-slot:body>
              <div class="d-flex d-flex align-items-center justify-content-between">
                <div>
                  <h2>{{ reservations.approved }}</h2>
                  <p class="fontsize-sm m-0">
                    Approved Reservation(s)
                  </p>
                </div>
                <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                  <i class="ri-inbox-fill" />
                </div>
              </div>
            </template>
          </iq-card>
        </router-link>
      </b-col>
      <b-col
        cols="12"
        sm="4"
      >
        <router-link :to="{ name: 'logistics-officer.reservations.histories', params: {status: 'Disapproved'}}">
          <iq-card>
            <template v-slot:body>
              <div class="d-flex d-flex align-items-center justify-content-between">
                <div>
                  <h2>{{ reservations.disapproved }}</h2>
                  <p class="fontsize-sm m-0">
                    Disapproved Reservation(s)
                  </p>
                </div>
                <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-danger">
                  <i class="ri-inbox-fill" />
                </div>
              </div>
            </template>
          </iq-card>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { SLODashboard } from '@/services'

export default {
  name: 'VSLODashboard',

  middleware: ['auth', 'logistics-officer'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  data () {
    return {
      reservations: {
        pending: 0,
        approved: 0,
        disapproved: 0
      }

    }
  },

  mounted () {
    core.index()
    this.fetchReservations()
  },

  methods: {
    async fetchReservations () {
      await SLODashboard.getStatistics().then(({ data }) => {
        this.reservations.pending = data.pending
        this.reservations.approved = data.approved
        this.reservations.disapproved = data.disapproved
      })
    }
  }
}
</script>
